export default __webpack_public_path__ + "static/media/space_object_08-min.4cce6e35.png";